/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/button-has-type */
import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd-v5';
import DropdownSelect from '../../../../Layout/DropdownSelect';
import { putRequest } from '../../../../../core/apiRequests';

const SnoozeModal = ({ openModal, setOpenModal, merchantId, actions, refresh }) => {
  const options = useMemo(
    () => [
      {
        label: 'Day',
        value: 'day',
      },
      {
        label: 'Week',
        value: 'week',
      },
      {
        label: 'Month',
        value: 'month',
      },
    ],
    [],
  );

  const [snoozeInterval, setSnoozeInterval] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSave = useCallback(async () => {
    const reqObj = {
      params: ['today', merchantId, 'delayReminders'],
      data: {
        snoozeInterval,
        actionIds: actions.map(action => action.id),
      },
    };
    setLoading(true);
    await putRequest(reqObj);
    setLoading(false);
    setOpenModal(false);
    refresh();
  }, [snoozeInterval, merchantId, actions]);

  const handleCancel = useCallback(() => {
    setOpenModal(false);
  }, []);

  return (
    <Modal
      title="Delay this reminder for another..."
      open={openModal}
      onCancel={handleCancel}
      onOk={handleSave}
      okText={loading ? 'Applying...' : 'Apply'}
      okButtonProps={{ disabled: !snoozeInterval }}
      confirmLoading={loading}
      destroyOnClose
      width={360}
      centered
    >
      <div className="m-top-25 m-btm-28">
        <DropdownSelect
          classProps="maw-100-P w-100-P align-left"
          options={options}
          placeholder="Select time frame"
          value={snoozeInterval}
          onChange={obj => {
            setSnoozeInterval(obj.value);
          }}
        />
      </div>
    </Modal>
  );
};

const mapStateToProps = state => ({ auth: state.auth, messaging: state.messaging });
export default connect(mapStateToProps, {})(SnoozeModal);
